import { GxIcon } from "./icon.js"


export class GxIconGlobe extends GxIcon {

  constructor() {
    super()
    const templ = document.createElement("template")
    templ.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"  aria-hidden="true">
  <circle cx="12" cy="12" r="10"></circle>
  <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path>
</svg>
`
    super.addHTML(templ)
  }
}

if (!window.customElements.get("gx-icon-globe")) window.customElements.define("gx-icon-globe", GxIconGlobe)
